import useGeneralStore from '../../../../store/general';
import customHeaders, { getSpace } from '../../../../common/headers';
import './CardItemAccount.scss'

const CardItemAccount = ({
    id,
    name,
    selected,
    setSelected
}) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    return (
        <label
            className={id == selected ? 'card-item-account_active' : 'card-item-account'}
            key={id}
        >
            <input
                type="radio"
                name="account"
                value={id}
                checked={id == selected}
                onChange={() => setSelected(id)}
            />
            <span className='tooltip_light-blue'>{name}</span>
        </label>
    )
}

export { CardItemAccount }